// extracted by mini-css-extract-plugin
export default {"wrap":"X4DZp6","btn":"RknDuY","btn-wrap":"m7LEU6","btn-wrap--next":"AHQIEX","btn-wrap--prev":"hfgt_l","btn-wrap__icon":"LIWgzp"};